import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Error boundary for lazy-loaded routes.
 * Catches chunk load failures (network errors, stale deployments) and offers
 * a reload action instead of crashing to a white screen.
 */
export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('Route chunk load failed:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-error">
          <p className="app-error-brand">Glide-Path</p>
          <h2>Failed to load page</h2>
          <p>Please check your internet connection and try again.</p>
          <div className="app-error-actions">
            <button
              className="app-error-btn"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
            <a href="/" className="app-error-home-link">Go to home page</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
